// extracted by mini-css-extract-plugin
export default {"items":"Conocenos_items__ikg1J","visible":"Conocenos_visible__djF1I","invisible":"Conocenos_invisible__3hXOd","carrusell":"Conocenos_carrusell__pNJaV"};